import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { CalendarOptionResponse } from 'src/types/shared/Challenge';

export const fetchChallengeGroupOptionsForCalendarRequest = createAction(
    'fetchChallengeGroupOptionsForCalendarRequest',
);
export const fetchChallengeGroupOptionsForCalendarSuccess = createAction<CalendarOptionResponse>(
    'fetchChallengeGroupOptionsForCalendarSuccess',
);
export const fetchChallengeGroupOptionsForCalendarFailure = createAction(
    'fetchChallengeGroupOptionsForCalendarFailure',
);

export const fetchChallengeGroupOptionsForCalendar = () => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengeGroupOptionsForCalendarRequest());
    try {
        const { data } = await api.get<CalendarOptionResponse>(`admin/calendar/options`);
        dispatch(fetchChallengeGroupOptionsForCalendarSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengeGroupOptionsForCalendarFailure, e);
    }
};
